/**
 * SidebarActionBand - Optional action band above footer with Add New button
 * Provides a consistent place for primary actions related to the current list
 */
export default function SidebarActionBand({
  show = false,
  label = 'Add New',
  icon = 'M12 4v16m8-8H4', // Plus icon path
  onClick,
  isCollapsed = false,
  className = ''
}) {
  // Don't render if not shown or collapsed
  if (!show || isCollapsed) {
    return null;
  }

  return (
    <div className={`p-4 border-t border-gray-700 flex-shrink-0 ${className}`}>
      <button
        onClick={onClick}
        className="w-full flex items-center justify-center gap-2 px-4 py-3 bg-gradient-to-r from-purple-600 to-violet-600 hover:from-purple-700 hover:to-violet-700 rounded-lg transition-all duration-200 font-semibold shadow-lg shadow-purple-900/30 hover:shadow-xl hover:shadow-purple-900/40 hover:scale-[1.02] active:scale-[0.98]"
        style={{ color: 'var(--color-text-on-accent)' }}
      >
        <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2.5}>
          <path strokeLinecap="round" strokeLinejoin="round" d={icon} />
        </svg>
        <span>{label}</span>
      </button>
    </div>
  );
}
